import {apiSlice} from 'pm-api';

import {RecurringExpense} from '../types';

export const recurringRecurringExpensesApiSlice = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        createRecurringExpense: build.mutation({
            query:           (recurringExpense: RecurringExpense) => ({
                url:    '/auth/recurring-expenses',
                method: 'POST',
                body:   recurringExpense,
            }),
            invalidatesTags: () => [{type: 'RecurringExpense', id: 'LIST'}],
        }),
        getRecurringExpenses:   build.query<RecurringExpense[], any>({
            query:        (query) => ({
                url:    '/auth/recurring-expenses',
                params: query,
            }),
            providesTags: (res = []) => [
                {type: 'RecurringExpense', id: 'LIST'},
                ...res.map(({id}) => ({type: 'RecurringExpense' as const, id})),
            ],
        }),
        getRecurringExpense:    build.query({
            query:        (id) => ({
                url: `/auth/recurring-expenses/${id}`,
            }),
            providesTags: (_res, _err, arg) => [{type: 'RecurringExpense', id: arg}],
        }),
        updateRecurringExpense: build.mutation({
            query:           (recurringExpense: Partial<RecurringExpense>) => ({
                url:    `/auth/recurring-expenses/${recurringExpense.id}`,
                method: 'PATCH',
                body:   recurringExpense,
            }),
            invalidatesTags: (res, err) => {
                if (err) {
                    return [];
                }
                return [{type: 'RecurringExpense', id: res?.id}]
            },
        }),
        deleteRecurringExpense: build.mutation({
            query:           (id: string) => ({
                url:    `/auth/recurring-expenses/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (_res, err, arg) => {
                if (err) {
                    return [];
                }
                return [{type: 'RecurringExpense', id: arg}]
            },
        }),
    }),
})

export const {
    useCreateRecurringExpenseMutation,
    useGetRecurringExpensesQuery,
    useGetRecurringExpenseQuery,
    useUpdateRecurringExpenseMutation,
    useDeleteRecurringExpenseMutation,
} = recurringRecurringExpensesApiSlice
